var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8478 16.5451L11.517 21.0122C11.9903 21.0122 12.1953 20.817 12.4412 20.5826L14.6604 18.5467L19.2589 21.7794C20.1022 22.2306 20.6964 21.993 20.9239 21.0346L23.9423 7.45712L23.9431 7.45632C24.2106 6.25952 23.4923 5.79153 22.6706 6.08512L4.9285 12.6059C3.71764 13.0571 3.73598 13.7051 4.72266 13.9987L9.25861 15.3531L19.7947 9.02431C20.2905 8.70911 20.7414 8.88351 20.3705 9.19871L11.8478 16.5451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2afc93af5737791f7fd03048dd400213.svg";
export { ForwardRef as ReactComponent };